import { render } from "./MyCustomPlugin.vue?vue&type=template&id=fc8f4cea"
import script from "./MyCustomPlugin.vue?vue&type=script&lang=js"
export * from "./MyCustomPlugin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../DIARC/pixonanimation.az/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__